<template>
  <div class="coupon-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          @showDetail="showDetail">
      <ui-button :color="'green'"
                 @click="toggleInsert">
        <i class="xi-plus"></i> FAQ 추가
      </ui-button>
    </template-search-list>

    <template-insert :show="show.insert"
                     :metaApi="insertMetaApi"
                     :insertApi="insertApi"
                     @input="insertInput"
                     @reload="reloadList"
                     @saved="showDetail"
                     @close="toggleInsert">
      <h4 class="title"><i class="bi-ba"></i> FAQ 추가</h4>

      <ui-button :color="'blue'"
                 @click="togglePreview(model)">
        <i class="xi-eye"></i> 미리보기
      </ui-button>
    </template-insert>

    <template-detail :infoApi="infoApi"
                     :editApi="editApi"
                     :removeApi="removeApi"
                     :apiParam="apiParam"
                     @input="insertInput"
                     @reload="reloadList">
      <ui-button :color="'blue'"
                 @click="togglePreview(model)">
        <i class="xi-eye"></i> 미리보기
      </ui-button>
    </template-detail>

    <faq-preview :data="preview"
                 @close="togglePreview(false)"/>
  </div>
</template>

<script>
import { getBaFaqList, getBaFaqInfo, getBaFaqInsertMeta, insertBaFaq, removeBaFaq, updateBaFaq } from '@/api/marketing'

import FaqPreview from '@/components/marketing/faq/FaqPreview'

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateInsert from '@/components/_template/Insert'
import TemplateDetail from '@/components/_template/Detail'
import UiButton from '@/components/_ui/UiButton'

export default {
  name: 'BaFaqList',
  components: {
    FaqPreview,
    TemplateSearchList,
    TemplateInsert,
    TemplateDetail,
    UiButton
  },
  methods: {
    showDetail (data) {
      this.apiParam = { id: data.id || data.groupId }
      this.model = { ...data }
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    insertInput (field, value) {
      this.$set(this.model, field, value)
    },
    togglePreview (value = false) {
      if (value) {
        this.preview = {
          ...value,
          serviceType: 'ba'
        }
      } else {
        this.preview = false
      }
    }
  },
  data () {
    return {
      reload: 0,

      infoApi: getBaFaqInfo,
      editApi: updateBaFaq,
      removeApi: removeBaFaq,
      insertApi: insertBaFaq,
      insertMetaApi: getBaFaqInsertMeta,
      apiParam: null,

      listApi: getBaFaqList,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-publishAt',

      show: {
        insert: false
      },

      preview: false,
      model: {}
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-list-wrap {
}
</style>
